import React from 'react';
import {
  ComposableMap,
  Geographies,
  Geography,
  Annotation,
} from 'react-simple-maps';

const Map = () => {
  return (
    <ComposableMap
      projection='geoAzimuthalEqualArea'
      projectionConfig={{
        rotate: [-10.0, -52.0, 0],
        center: [-5, -3],
        scale: 1600,
      }}
      style={{ width: '100%' }}>
      <Geographies
        geography='/features.json'
        fill='transparent'
        stroke='#FFFFFF'
        strokeWidth={0.5}>
        {({ geographies }) =>
          geographies.map((geo) => (
            <Geography key={geo.rsmKey} geography={geo} />
          ))
        }
      </Geographies>
      <Annotation
        subject={[0.1276, 51.5072]}
        dx={-90}
        dy={-30}
        connectorProps={{
          stroke: '#FFFFFF',
          strokeWidth: 2,
          strokeLinecap: 'round',
        }}>
        <text x='-8' textAnchor='end' alignmentBaseline='middle' fill='#FFFFFF'>
          {'London'}
        </text>
      </Annotation>
    </ComposableMap>
  );
};

export default Map;
